import React, { FC, useEffect, useState } from 'react';

interface ITimoutRedirectProps {
  seconds: number,
  text: string,
  href: string,
  className?: string,
}

const TimoutRedirect: FC<ITimoutRedirectProps> = ({ seconds, text, href, className = '' }) => {
  const [time, setSetTime] = useState(seconds);

  useEffect(() => {
    setTimeout(() => {
      document.location.href = href;
    }, seconds * 1000);

    const interval = setInterval(() => {
      setSetTime(time => time - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <p className={className}>{text}: {time || 0}</p>
  )
}

export default TimoutRedirect;